import React, { useState } from 'react';
import { refreshAllDeclarations } from '../api/declarationService';

function GlobalRefreshButton({ 
  onRefreshComplete, 
  onRefreshStart,
  className, 
  disabled 
}) {
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  const handleClick = () => {
    setIsRefreshing(true);
    
    if (onRefreshStart && typeof onRefreshStart === 'function') {
      onRefreshStart();
    }
    
    refreshAllDeclarations()
      .then(result => {
        if (onRefreshComplete && typeof onRefreshComplete === 'function') {
          onRefreshComplete(result);
        }
      })
      .catch(error => {
        console.error('Error during global refresh:', error);
      })
      .finally(() => {
        setIsRefreshing(false);
      });
  };
  
  const buttonClasses = `${className || "button-hide"} ${isRefreshing ? 'refreshing' : ''}`;
  
  return (
    <button 
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled || isRefreshing}
    >
      <span style={{ 
        opacity: isRefreshing ? 0.7 : 1,
        transition: 'opacity 0.3s ease',
        display: 'flex',
        alignItems: 'center'
      }}>
        <svg 
          xmlns="https://www.w3.org/2000/svg" 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          style={{ 
            marginRight: '6px',
            transition: 'transform 0.3s ease',
            transform: isRefreshing ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        >
          <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
        </svg>
        Refresh All Declarations
      </span>
    </button>
  );
}

export default GlobalRefreshButton;